export default {
  follow: 'Suivre cet espace',
  following: 'Vous suivez cet espace',
  title: 'Notifications de cet espace',
  subtitle: "Recevez un e-mail pour ce qui se passe ici, quel que soit votre choix pour le reste de l'organisation.",
  kinds: {
    uploadReceived: 'Nouveaux fichiers',
    uploadPendingModeration: 'Fichiers à valider',
  },
  unknownKind: 'Autre notification',
  sources: {
    memberScoped: 'Votre choix pour cet espace',
    member: "Selon votre choix pour toute l'organisation",
    organization: "Selon le défaut de l'organisation",
    registry: 'Selon le défaut',
    none: 'Désactivé',
  },
  mandatory: 'Obligatoire : ne peut pas être désactivé',
  manage: 'Gérer mes notifications',
  followed: 'Vous suivez cet espace',
  unfollowed: 'Vous ne suivez plus cet espace',
  refusals: {
    mandatory: 'Cette notification est obligatoire par e-mail.',
    notEligible: 'Cette notification ne vous concerne plus.',
    notSelectable: "Ce canal n'est pas encore disponible.",
    failed: "Le changement n'a pas pu être enregistré.",
  },
}
